import { Component } from '@angular/core';
import { NavController,ViewController, ModalController } from 'ionic-angular';
import { LoadingProvider } from '../../providers/loading/loading';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Platform } from 'ionic-angular';
import { LoginPage } from '../login/login';
import swal from 'sweetalert';
import { HomePage } from '../home/home';
import { CreateSubAccountsPage } from '../create-subaccount/create-subaccount';
import { InAppBrowser,InAppBrowserEvent } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-highlevel',
  templateUrl: 'highlevel.html',
})
export class HighLevelPage {
  errorMessage = '';
  ghl_key = new String;
  tw_key = new String;
  tw_account_SID = new String;
  Availablepipeline = new Array;
  chosenPipeline = new Array;
  AvailableStages = new Array;
  chosenPipelineStage = new Array;
  AvailableNumbers = new Array();
chosenTwilioNumber = new Array;
chosenCalendar = new Array;
AvailableCalendars = new Array;


  constructor(
    public http: Http,
    public navCtrl: NavController,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,
    public platform: Platform,
    private camera: Camera,
    private iab: InAppBrowser
  ) {

  }

  ionViewDidEnter() {

}

SelectCalendar(){
  console.log("Calendar Selected is: " , this.chosenCalendar);
}

SelectFirstPipelineStage(){

  console.log("First Pipeline Stage is: " , this.chosenPipelineStage);
}

ghlKeyChange(){
  console.log("GHL Key Change:",this.ghl_key);
  this.shared.customerData.ghl_token = this.ghl_key ;
  this.Availablepipeline = [];
  this.chosenPipeline = [];
  this.AvailableStages = [];
  this.chosenPipelineStage = [];
  this.chosenCalendar = [];
  this.AvailableCalendars = [];


  this.getPipelines();

}

SelectPipelineStage(){

  console.log("Select Pipeline Stage for :" , this.chosenPipeline);

  this.Availablepipeline.forEach(function (value, index,chosenPipeline) {
      if (value.id ==this.chosenPipeline ) {
          this.getCalendars();
          console.log("Value: " , value.name);
          console.log("Value: " , value.stages);
          this.AvailableStages = value.stages;
      }
  },this);

}

disconnectStrip(){
  console.log("Disconnect Stripe");
  var postdata: { [k: string]: any } = {};
  postdata.customer_id = this.shared.customerData.customers_id;
  postdata.access_token = null;
  postdata.stripe_connect_user = null;
  postdata.stripe_refresh = null;
  //console.log("Post Data:",JSON.stringify(postdata));
  this.http.post(this.config.url + 'storeStripeToken', postdata).map(res => res.json()).subscribe(data => {

    if (data.success == 1) {
      //console.log("Store Stripe Token Response:",data);
      this.shared.customerData.sk_key  = null;;

    }
  });
}

connectwithStrip(){
  console.log("Connect with Stripe");
  // DEBUG var url = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_Jd2qgu6YdoTdYaFqycPC0TPR9yhv0ZTv&scope=read_write&output=embed';
  //PROD
  //
  var url = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_Jd2qkOIWY7zsJ4qX51okCtymOA5QOx9k&scope=read_write&output=embed';




  const browser = this.iab.create(url, '_blank', 'location=no');
  browser.on('loadstop').subscribe(event => {
    //console.log("Got Event:",JSON.stringify(event))
      if ((event.url).indexOf('&code=') !== -1) {
        let token = event.url.slice(event.url.indexOf('&code=') + '&code='.length);
        // here is your token, now you can close the InAppBrowser
        //console.log("Got Token:",token)
        //POst to Server to get API Keys and refresh Token
        var data: { [k: string]: any } = {};

        data.token = token


        this.http.post(this.config.url + 'stripeConnect', data).map(res => res.json()).subscribe(data => {

          if (data.success == 1) {
            console.log("Response:",JSON.stringify(data));
            var postdata: { [k: string]: any } = {};
            var stripeInfo =JSON.parse(data.data);
            postdata.customer_id = this.shared.customerData.customers_id;
            postdata.access_token = stripeInfo.access_token;
            this.shared.customerData.sk_key  = stripeInfo.access_token;
            postdata.stripe_connect_user = stripeInfo.stripe_user_id;
            postdata.stripe_refresh = stripeInfo.refresh_token;
            console.log("Post Data:",JSON.stringify(postdata));
            this.http.post(this.config.url + 'storeStripeToken', postdata).map(res => res.json()).subscribe(data => {

              if (data.success == 1) {
                console.log("Store Stripe Token Response:",data);


              }
            });


          }
        });
        browser.close();
      }
    })
}

updateAvailPhoneNumbers(){

  var data: { [k: string]: any }

  this.http.get(this.config.url + 'getincomingPhoneNumber?sid=' +this.tw_account_SID + '&token=' +this.tw_key ).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      console.log("Got:",data);
      this.AvailableNumbers = data.numbers
      console.log("Available Numbers:",this.AvailableNumbers);
      if(this.shared.customerData.tw_number != "")
      {
        //We already have a phone numbers
        console.log("Check if current number matches");

        //Check to see if this matches anything in GHL account

        this.AvailableNumbers.forEach(function (value, index,tw_number) {
            if (value.phone_number == this.shared.customerData.tw_number) {

                console.log("Chosen Number Value: " , value.phone_number);
                this.chosenTwilioNumber = value.phone_number;
            }
          },this);
        }
      }
        });


}

SaveConfig(){
  console.log("Save config for :", this.shared.customerData);


  var data: { [k: string]: any } = {};

  data.customer_id = this.shared.customerData.customers_id;
  data.ghl_token = this.ghl_key;
  data.ghl_lead_pipeline_id = this.chosenPipeline;
  data.ghl_stage_id = this.chosenPipelineStage;
  data.tsid = this.tw_account_SID;
  data.tw_token = this.tw_key;
  data.tw_number = this.chosenTwilioNumber;
  data.ghl_calendar_id = this.chosenCalendar;


  this.http.post(this.config.url + 'saveIntegrations', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      console.log("Response:",data);
      this.shared.customerData.ghl_calendar_id = this.chosenCalendar;
    }
  });

}

getNumbers(){


  var data: { [k: string]: any }

  this.http.get(this.config.url + 'getincomingPhoneNumber?sid=' +this.shared.customerData.tsid + '&token=' +this.tw_key ).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      console.log("Got:",data);
      this.AvailableNumbers = data.numbers
      console.log("Available Numbers:",this.AvailableNumbers);
      if(this.shared.customerData.tw_number != "")
      {
        //We already have a phone numbers
        console.log("Check if current number matches");

        //Check to see if this matches anything in GHL account
        this.AvailableNumbers.forEach(function (value, index) {

            if (value.phone_number == this.shared.customerData.tw_number) {

                console.log("Chosen Number Value: " , value.phone_number);
                this.chosenTwilioNumber = value.phone_number;
            }
          },this);
        }
      }
        });
    }

getCalendars(){

  var data: { [k: string]: any }
  this.http.get(this.config.url + 'getCalendars?ghl_token=' +this.shared.customerData.ghl_token).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {

      this.AvailableCalendars = data.calendars.services;
      console.log("Calendars:",this.AvailableCalendars);
      if(this.shared.customerData.ghl_calendar_id != "")
      {
        this.AvailableCalendars.forEach(function (value, index,ghl_lead_pipeline_id) {
            if (value.id ==this.shared.customerData.ghl_calendar_id ) {

                console.log("Chosen Pipeline Value: " , value.name);
                this.chosenCalendar = value.id;


            }
        },this);

      }
    }
  });

}

getPipelines(){


  var data: { [k: string]: any }
  this.http.get(this.config.url + 'getPipelines?ghl_token=' +this.shared.customerData.ghl_token).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      if(data.pipelines.pipelines != undefined)
      {
      this.Availablepipeline = data.pipelines.pipelines;
      console.log("Pipelines:",this.Availablepipeline);
      }
      if(this.shared.customerData.ghl_lead_pipeline_id != "")
      {
        //We already have a pipeline Id

        //Check to see if this matches anything in GHL account

        this.Availablepipeline.forEach(function (value, index,ghl_lead_pipeline_id) {
            if (value.id ==this.shared.customerData.ghl_lead_pipeline_id ) {

                console.log("Chosen Pipeline Value: " , value.name);
                this.chosenPipeline = value.id;
                this.AvailableStages = value.stages;

            }
        },this);

        console.log("Got these stages: " ,this.AvailableStages );

        this.AvailableStages.forEach(function (value, index) {
            if (value.id.replace(/\s/g, "_") === this.shared.customerData.ghl_stage_id.replace(/\s/g, "_")) {

                console.log("Chosen Stage Value: " , value.id);
                this.chosenPipelineStage = value.id;
            }

        },this);



      }
      }
    });


}

ngOnInit() {
  console.log("Customer info:",this.shared.customerData);
  this.ghl_key = this.shared.customerData.ghl_token;
  this.tw_key = this.shared.customerData.tw_token
  this.tw_account_SID = this.shared.customerData.tsid;

  this.getPipelines();
  this.getCalendars();
  if (this.tw_key != "" &&   this.tw_account_SID != ""){

    this.getNumbers();
  }

}




}



// WEBPACK FOOTER //
// ./src/pages/highlevel/highlevel.ts